import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ArticleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/articles/${id}`)
      .then((r) => setArticle(r.data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || e.message));
  }, [id]);

  if (error) {
    return (
      <div>
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-6">
          {error}
        </div>
        <Button onClick={() => navigate("/pricing")} className="mt-4 bg-blue-800 text-white">
          View memberships
        </Button>
      </div>
    );
  }

  if (!article) return <div className="text-slate-500">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto">
      <div className="text-xs uppercase tracking-[0.28em] text-blue-800 font-semibold mb-3">
        {article.category} · {article.read_time}
      </div>
      <h1 className="font-display font-black text-4xl sm:text-5xl text-slate-900 leading-[1.05] tracking-tighter">
        {article.title}
      </h1>
      <img
        src={article.cover_image}
        alt=""
        className="mt-8 rounded-2xl w-full aspect-[16/9] object-cover"
      />
      <div className="mt-10 prose prose-slate max-w-none text-slate-700 leading-relaxed whitespace-pre-wrap">
        {article.body}
      </div>
    </article>
  );
}
